import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Form, Formik } from "formik";
import React from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { forgotPassword } from "../../actions/authAction";
import FormikControl from "../../components/WraapperComponent/FormikControl";
import { getUserDetail } from "../../utils/helper";
const ChangeEmailPopup = ({ closePopup }) => {
  const dispatch = useDispatch();
  const appLoading = useSelector((state) => state.alert.appLoading);
  const initialValues = {
    email: "",
  };

  const validationSchema = Yup.object({
    email: Yup.string().nullable().email().required("This field is required"),
  });

  const onSubmit = (values) => {
    var actionName = "userChangeEmail";
    var params = {
      action: actionName,
      email: values.email,
      token: getUserDetail()?.token,
    };
    dispatch(
      forgotPassword({ params }, () => {
        closePopup();
      })
    );
  };
  return (
    <Modal size="lg" show={true}>
      <Modal.Header>
        <div className="modal-title">
          <h5 className="profile-title">Change Email</h5>
          <FontAwesomeIcon icon={faTimesCircle} onClick={closePopup} />
        </div>
      </Modal.Header>
      <Modal.Body>
        <div>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {({ errors, touched, setFieldValue }) => {
              return (
                <Form>
                  <div className="row">
                    <div className="col-sm-12">
                      <FormikControl
                        control="forminput"
                        type="text"
                        label="* Email"
                        name="email"
                        hasError={errors.email && touched.email}
                      />
                    </div>
                  </div>
                  <div className="submit-section mt-2">
                    <button
                      className="btn-orange"
                      type="submit"
                      disabled={appLoading}
                    >
                      Save
                    </button>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default ChangeEmailPopup;
